module.exports = __webpack_public_path__ + "img/cards_back.7bacfcc4.png";